export default "__VITE_ASSET__Drdb_yPZ__"